import { BasicRequest } from "./basicRequest";

export class DeleteCustomerPremierPartnerServiceConfigurationRequest extends BasicRequest{

    premierServiceConfigurationId!:number;

    constructor(){
        super();
    }
}